import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllProject } from '../../../Redux/Apis/projectApi';
import Loader from '../../atoms/Loader/Loader';
import EditIcon from "../../../assets/icon/edit.png"
import { checkPermission, permissionType } from '../../../app/utils/common/Functions';
import './AssignedProjectList.scss';

const formatAssignees = (assignees = []) =>
    assignees
        .map((profile) => `${profile.firstname || ''} ${profile.lastname || ''}`.trim())
        .filter(Boolean)
        .join(', ') || '—';

const formatProjectTypeLabel = (projectType) =>
    projectType === "internal" ? "Internal" : "Client";

const AssignedProjectList = ({ editProject }) => {
    const dispatch = useDispatch();
    const { projects, loading, isProjectUpdated } = useSelector(state => state.project);
    const [currentPage, setCurrentPage] = useState(1);
    const projectsPerPage = 10;
    const canUpdate = checkPermission(permissionType.PROJECT_MANAGEMENT, "update");

    const indexOfLastProject = currentPage * projectsPerPage;
    const indexOfFirstProject = indexOfLastProject - projectsPerPage;
    const currentProjects = projects.slice(indexOfFirstProject, indexOfLastProject);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const totalPages = Math.ceil(projects.length / projectsPerPage);

    useEffect(() => {
        if (isProjectUpdated) {
            dispatch(getAllProject())
        }
    }, [isProjectUpdated, dispatch])

    const renderPagination = () => {
        if (totalPages <= 1) return null;

        return (
            <div className="assigned-projects-pagination">
                <button
                    type="button"
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                    className={`px-3 py-1 mx-1 rounded ${currentPage === 1 ? 'bg-[#e7ecf8] text-[#94a0b8] cursor-not-allowed' : 'bg-btn-primary text-white '}`}
                >
                    Prev
                </button>

                {[...Array(totalPages)].map((_, i) => (
                    <button
                        type="button"
                        key={i}
                        onClick={() => paginate(i + 1)}
                        className={`px-3 py-1 mx-1 rounded ${currentPage === i + 1 ? 'bg-btn-primary text-white' : 'bg-[#eef2fc] text-[#687895]'}`}
                    >
                        {i + 1}
                    </button>
                ))}

                <button
                    type="button"
                    onClick={() => paginate(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className={`px-3 py-1 mx-1 rounded ${currentPage === totalPages ? 'bg-[#e7ecf8] text-[#94a0b8] cursor-not-allowed' : 'bg-btn-primary text-white '}`}
                >
                    Next
                </button>
            </div>
        );
    };

    return (
        <div className='assigned-projects-list card-border card-body mb-4'>
            {loading ? (
                <div className='w-full min-h-[200px] flex items-center justify-center'>
                    <Loader />
                </div>
            ) : (
                <>
                    <div className="assigned-projects-table-wrap">
                        <table className='table-default assigned-projects-table w-full'>
                            <thead>
                                <tr className='text-left'>
                                    <th>#</th>
                                    <th>Project Name</th>
                                    <th>Type</th>
                                    <th>Developers</th>
                                    {canUpdate && <th>Edit</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {currentProjects.map((project, index) => (
                                    <tr key={project._id || project.projectId || index}>
                                        <td>{indexOfFirstProject + index + 1}</td>
                                        <td>{project.projectName}</td>
                                        <td>{formatProjectTypeLabel(project.projectType)}</td>
                                        <td className='assignees-cell'>
                                            {formatAssignees(project.assignees)}
                                        </td>
                                        {canUpdate && (
                                            <td>
                                                <div className="assigned-project-action-cell">
                                                    <button
                                                        type="button"
                                                        className="assigned-project-edit-btn"
                                                        onClick={() => editProject(project)}
                                                        aria-label={`Edit ${project.projectName}`}
                                                    >
                                                        <img src={EditIcon} alt="" />
                                                    </button>
                                                </div>
                                            </td>
                                        )}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="assigned-projects-cards" aria-label="Assigned projects list">
                        {currentProjects.map((project, index) => (
                            <article
                                key={project._id || project.projectId || index}
                                className="assigned-project-card"
                            >
                                <header className="assigned-project-card__header">
                                    <span className="assigned-project-card__index">
                                        {indexOfFirstProject + index + 1}
                                    </span>
                                    <div className="assigned-project-card__title-wrap">
                                        <h3 className="assigned-project-card__name">
                                            {project.projectName}
                                        </h3>
                                    </div>
                                </header>

                                <div className="assigned-project-card__section">
                                    <span className="assigned-project-card__label">Type</span>
                                    <p className="assigned-project-card__developers">
                                        {formatProjectTypeLabel(project.projectType)}
                                    </p>
                                </div>

                                <div className="assigned-project-card__section">
                                    <span className="assigned-project-card__label">Developers</span>
                                    <p className="assigned-project-card__developers">
                                        {formatAssignees(project.assignees)}
                                    </p>
                                </div>

                                {canUpdate && (
                                    <footer className="assigned-project-card__actions">
                                        <button
                                            type="button"
                                            className="assigned-project-card__edit-btn"
                                            onClick={() => editProject(project)}
                                        >
                                            <img src={EditIcon} alt="" />
                                            Edit
                                        </button>
                                    </footer>
                                )}
                            </article>
                        ))}
                    </div>

                    {renderPagination()}
                </>
            )}
        </div>
    )
}

export default AssignedProjectList
